<template>
  <piece-card title="今日值班">
    <div class="duty-list">
      <div class="duty-item" v-for="(item, index) in showList" :key="index">
        <div class="duty-title">{{ item.title }}</div>
        <div class="duty-content">
          <div class="member-item" v-for="(member, i) in item.list" :key="i">
            <div class="item-icon"></div>
            <div class="item-value ellipsis">{{ member.label }}：{{ member.value }}</div>
          </div>
        </div>
      </div>
    </div>
  </piece-card>
</template>

<script>
import PieceCard from "../../components/piece-card.vue";

export default {
  name: "Duty",
  components: {
    PieceCard,
  },
  props: {
    info: { type: Object },
  },
  data() {
    return {};
  },
  computed: {
    showList() {
      const { ktzb = {}, dtzb = {} } = this.info || {};
      const ktzbList = [
        { key: "jd", label: "接待", value: "" },
        { key: "rs", label: "人事", value: "" },
        { key: "fs", label: "佛事", value: "" },
        { key: "xz", label: "行政", value: "" },
        { key: "zk", label: "照客", value: "" },
        { key: "jqzb", label: "景区值班", value: "" },
      ];
      const dtzbList = [
        { key: "twd", label: "天王殿", value: "" },
        { key: "dxbd", label: "大雄宝殿", value: "" },
        { key: "ysd", label: "药师殿", value: "" },
        { key: "lht", label: "罗汉堂", value: "" },
        { key: "jld", label: "伽蓝殿祖师殿", value: "" },
        { key: "jgd", label: "济公殿", value: "" },
        { key: "vws", label: "文物室", value: "" },
        { key: "hyd", label: "华严殿", value: "" },
        { key: "pwt", label: "牌位堂", value: "" },
        { key: "jd", label: "机动", value: "" },
      ];
      this.dealData(ktzbList, ktzb);
      this.dealData(dtzbList, dtzb);
      return [
        { title: "客堂值班", list: ktzbList },
        { title: "殿堂值班", list: dtzbList },
      ];
    },
  },
  methods: {
    dealData(list, data) {
      list.forEach((item) => {
        item.value = data[item.key]?.map((item) => item.name)?.join(" ");
      });
    },
  },
};
</script>

<style lang="less" scoped>
.duty-item {
  &:not(:last-of-type) {
    margin-bottom: 15px;
  }
}
.duty-title {
  color: #fff;
  font-family: "PingFang SC";
  font-size: 16px;
  padding-bottom: 10px;
}
.duty-content {
  padding: 15px;
  background-color: rgba(242, 204, 0, 0.15);
  display: flex;
  flex-wrap: wrap;
}
.member-item {
  flex: none;
  width: 50%;
  padding-left: 3px;
  display: flex;
  align-items: center;
  &:nth-child(n + 2) {
    margin-top: 4px;
  }
}
.item-icon {
  flex-shrink: 0;
  width: 7px;
  height: 7px;
  background-color: var(--primary-color);
  margin-right: 6px;
}
.item-value {
  flex: 1;
  min-width: 0;
  color: #f9e6b3;
  font-family: "Source Han Sans CN";
  font-size: 15px;
}
</style>
